function Waypoints() {
	var self = this;
	this.init();
}

Waypoints.prototype.init = function() {
	var self = this;
	this.showItemsOnLoad();
	this.showItemsOnScroll();
};

Waypoints.prototype.showItemsOnLoad = function() {
	var self = this;
	$(window).on('load', function() {
		$('.load-wpt').addClass('-active');
	});
};

Waypoints.prototype.showItemsOnScroll = function() {
	var self = this;

	var wpt = $('.wpt');

	$.each(wpt, function() {
		var that = $(this);
		that.waypoint({
			element: that,
			handler: function(dir) {
				if (dir == 'down') {
					that.addClass('-active');
				} else {
					that.removeClass('-active');
				}
			},
			offset: '90%'
		});
	});
};